import { optionalHumanBoolean } from '../text/humanBoolean';
export const makeFullyQualifiedPropertyType = (property) => {
    if (!property.type && property.is_hmo == null)
        return null;
    const isHmo = optionalHumanBoolean(property.is_hmo, '', 'HMO', 'Non-HMO');
    const name = property.type?.name ?? '';
    return `${isHmo} ${name}`.trim();
};
